module.exports = __webpack_public_path__ + "img/Windfish-LinkMarker.80cc10b4.jpg";